import { render, staticRenderFns } from "./PageAddresses.vue?vue&type=template&id=a89b31e0&scoped=true&"
import script from "./PageAddresses.vue?vue&type=script&lang=ts&"
export * from "./PageAddresses.vue?vue&type=script&lang=ts&"
import style0 from "./PageAddresses.vue?vue&type=style&index=0&id=a89b31e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b31e0",
  null
  
)

export default component.exports